import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, FooterTwo } from "../containers";
export default function PrivacyPolicy() {
  return (
    <Fragment>
      <Seo
        title="Privacy Policy - Tech Ayukta"
        description="Read Tech Ayukta’s Privacy Policy to learn how we collect, use, and protect your personal information in compliance with data protection laws."
        keywords="Privacy Policy, Data Protection, Personal Information, Tech Ayukta"
        canonical="https://www.techayukta.com/privacy-policy"
      />

      <HeaderThree />
      <Breadcrumb
        pageName="Privacy Policy"
        bgImage="/images/breadcumb/breadcumb-bg.jpg"
      />
      <div className="container mx-auto px-6 py-12">
        <h3 className="text-3xl font-bold mt-4 mb-6">Privacy Policy</h3>
        <p className="mb-4">
          At <strong>Tech Ayukta</strong>, we value and respect your privacy.
          This Privacy Policy explains how we collect, use, and protect your
          personal information when you interact with our website, products, and
          services.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          1. Information We Collect
        </h4>
        <p className="mb-4">
          We may collect personal details such as name, email, phone number, and
          business information that you voluntarily provide when contacting us,
          subscribing to newsletters, or using our services.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          2. How We Use Information
        </h4>
        <p className="mb-4">
          We use collected data to deliver services, respond to inquiries,
          enhance user experience, and provide relevant updates regarding our
          offerings.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">3. Data Security</h4>
        <p className="mb-4">
          We implement strict security measures to safeguard your personal data
          from unauthorized access, alteration, or disclosure.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          4. Sharing of Information
        </h4>
        <p className="mb-4">
          We do not sell, rent, or trade your personal information. Data may
          only be shared with trusted partners who assist us in delivering our
          services, under strict confidentiality agreements.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h4>
        <p className="mb-4">
          You may request access, correction, or deletion of your personal
          information at any time by contacting us directly.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          6. Updates to this Policy
        </h4>
        <p className="mb-4">
          Tech Ayukta may update this Privacy Policy periodically. We encourage
          users to review this page regularly to stay informed.
        </p>

        <p className="mt-8 text-sm">
          If you have any questions regarding this Privacy Policy, please
          contact us at <strong>techsupport@techayukta.com</strong>.
        </p>
      </div>
      <FooterTwo />
      <ScrollTopBtn />
    </Fragment>
  );
}
